import { apiFetch } from '../shared/api'
import type { PrefectureOfferCountsResponse, PrefectureOfferCounts } from './types'

const PREFECTURE_OFFER_COUNTS_ENDPOINT = '/api/v1/prefecture_offer_counts'

/**
 * 都道府県ごとの募集中求人数を47都道府県分まとめて取得する（/offers 一覧の件数と同じ定義）。
 * 0件の都道府県はキーを持たないので、参照側で 0 を既定値にすること。
 *
 * @returns 都道府県ID（文字列）をキー、募集中求人数を値に持つオブジェクト
 */
export const fetchPrefectureOfferCounts =
    async (): Promise<PrefectureOfferCounts> => {
        const response = await apiFetch<PrefectureOfferCountsResponse>(
            PREFECTURE_OFFER_COUNTS_ENDPOINT
        )

        return response.data ?? {}
    }
